import * as React from 'react';
import {VideoStatusBar} from './status-bar';
import {VideoStatusMessage} from './status-message';
import {statusToColor} from './service';
import {STATUS_NO_ACCESS} from '../../redux/modules/video/constants';
import {webSocketDisabled, webRtcDisabled} from '../../utils/helpers';

import {
    wrap                    as cssWrap,
    container               as cssContainer,
    component               as cssComponent,
    componentConnectionless as cssComponentConnectionless,
} from './video-pane.module.sass';

export class ConnectionlessVideo extends React.Component<any, any> {
  public render(): React.ReactElement<any> {
    const {props: {draggable, isShowingPeerScreen}} = this;
    let msg;

    if (isShowingPeerScreen) {
      msg = 'In a real interview, if your peer chooses to share their screen, it will appear here.'
    } else if (webSocketDisabled() || webRtcDisabled()) {
      msg = "In a real interview, please connect using a browser with WebRTC support, such as Chrome or Firefox, to have your video and your peer's video displayed in this floating panel.";
    } else {
      msg = "In a real interview, your video as well as your peer\'s video would appear instead of this black box.";
      if (draggable) {
        msg += " Oh, and did you notice that the video pane is draggable? Move it around and see!";
      }
    }

    return (
      <div className={cssWrap}>
        <div className={cssContainer}>
          <VideoStatusMessage
            title={'This is a demo interview'}
            subTitle={msg}
            loader={false}
          />

          <div className={`${cssComponent} ${cssComponentConnectionless}`} />

          <VideoStatusBar
            selfColor={statusToColor(STATUS_NO_ACCESS)}
            peerColor={statusToColor(STATUS_NO_ACCESS)}
            isSendingScreen={false}
          />
        </div>
      </div>
    );
  }
}
